"use strict";
// @ts-ignore
try {
    self['workbox:background-sync:6.1.5'] && _();
}
catch (e) { }
